import {
  StakingContract,
  useApproval,
  useDepositAction,
  useMainToken,
  useUser,
} from '@trustpad/launchpad';
import { StakingContractV2 } from '@trustpad/launchpad/dist/staking/hooks/useStakingContract';

import * as React from 'react';
import { useState } from 'react';

import { CustomInput } from '~common/CustomInput';
import { useModalProvider } from '~common/hooks/useModalProvider';
import { MaxButton } from '~common/UI';
import { APPROVE_VALUE } from '~config/constants';
import { TPAD } from '~config/tokens';
import { ActionButton } from '~features/ui';
import { denormalizeDecimals, fNum, toEth, toWeiBN } from '~utils';

export function StakeBlock({
  halted,
  refreshAll,
  stakingContract,
}: {
  halted: boolean;
  refreshAll: VoidFunction;
  stakingContract: StakingContract | StakingContractV2;
}) {
  const { setMessage } = useModalProvider();
  const tokenContract = useMainToken();
  const { account, tokens } = useUser();
  const [value, setValue] = useState('');

  const {
    isApproved,
    isLoading: isApproving,
    approveSpending,
  } = useApproval({
    tokenContract,
    spenderAddress: stakingContract?.options.address,
    amount: denormalizeDecimals(toWeiBN(value), TPAD.decimals),
  });
  const { deposit, isLoading: isDepositing } = useDepositAction({
    contract: stakingContract,
    decimals: TPAD.decimals,
    refresh: refreshAll,
    messages: {
      success: (
        <p>
          Successfully deposited! <br />
          <br />
          Don't forget to <b>register for upcoming IDOs</b>, you can do that{' '}
          <b>by clicking "Register" on a pool page</b>, when registration period
          opens.
        </p>
      ),
      error: 'Deposit failed',
    },
  });

  // if (halted) {
  //   return (
  //     <div className="text-xl">
  //       Staking in this pool is disabled while the migration to TPAD 2.0 is
  //       ongoing.
  //     </div>
  //   );
  // }

  const isBtnDisabled =
    halted || isDepositing || !value || toWeiBN(value).gt(tokens);
  const isApproveDisabled = halted || isApproving || !account;

  return (
    <div className="gap-6 flex items-center flex-wrap justify-between">
      <div className="flex-shrink-0 flex-grow">
        <CustomInput
          name="value"
          value={value}
          onChange={setValue}
          topLabel={`Balance: ${fNum(tokens)} TPAD`}
          button={
            <MaxButton label="Max" onClick={() => setValue(toEth(tokens))} />
          }
          icon={<span className="text-gray-400">TPAD</span>}
        />
      </div>

      <div className="">
        {isApproved ? (
          <ActionButton
            isLoading={isDepositing}
            isDisabled={isBtnDisabled}
            onClick={() => deposit(value).then(setMessage).then(refreshAll)}
            className="w-28">
            Stake {halted && 'locked'}
          </ActionButton>
        ) : (
          <ActionButton
            isLoading={isApproving}
            isDisabled={isApproveDisabled}
            onClick={() => approveSpending(APPROVE_VALUE).then(setMessage)}
            className={isApproving ? '' : 'w-28'}>
            Approve
          </ActionButton>
        )}
      </div>
    </div>
  );
}
